import InstagramWidget from './InstagramWidget';
import TwitterWidget from './TwitterWidget';

export default class DynamicSocialWidgets {
  constructor(section) {
    this.el = section.el;
    this.$el = $(this.el);
    if ($('[data-instagram]', this.$el).length) {
      this.instagram = new InstagramWidget({ el: this.el });
    }
    if ($('[data-twitter]', this.$el).length) {
      this.twitter = new TwitterWidget({ el: this.el });
    }
  }

  update() {
    if (this.instagram) {
      this.instagram.update();
    }
    if (this.twitter) {
      this.twitter.update(this.$el);
    }
  }

  onSectionUnload() {
    this.instagram = null;
    this.twitter = null;
  }
}
